import React from 'react';
import { RemittanceIcon, InsuranceIcon, FinancingIcon, ReferralIcon, ReKYCIcon } from "../lead-inventory/icons";

/**
 * AccountCard - Mobile card view for account inventory
 * Displays account information in a touch-friendly card format
 */
const AccountCard = ({ data, onClick }) => {
  const getProfileStyle = (status) => {
    const styles = {
      'Fresh Meat': "bg-[#FFDAD4] text-black",
      Dormant: "bg-[#DFE0FF] text-black",
      Newbie: "bg-[#FFDAD4] text-black",
      'Farmable (Avg.)': "bg-[#FFEDE9] text-black",
      'Growth Potential': "bg-[#FFEDE9] text-black",
      'Core Customer (Loyal)': "bg-[#FFEDE9] text-black",
      Losers: "bg-[#DFE0FF] text-black",
      'Farmable (Loose)': "bg-[#FFDAD4] text-black",
      'Bargain Hunter': "bg-[#FFDAD4] text-black",
      'Need-Based (Avg.)': "bg-[#FFEDE9] text-black",
      'Farmable (Tight)': "bg-[#FFEEDC] text-black",
      'Need-Based (Loose)': "bg-[#FFDAD4] text-black",
      Wanderer: "bg-[#DFE0FF] text-black",
      'Need-Based (Tight)': "bg-[#FFDAD4] text-black",
      'Core Customer (Ex-GF)': "bg-[#DFE0FF] text-black"
    };
    return styles[status] || "bg-gray-100 text-gray-600";
  };

  const getChurnStatusStyle = (status) => {
    const styles = {
      Activated: "bg-[#F5FAE5] text-black",
      Dormant: "bg-[#FFF0F5] text-black",
      Sabik: "bg-[#EBF8FF] text-black",
      Sirius: "bg-[#FEFAD8] text-black",
      Spica: "bg-[#FBF29D] text-black",
      Sargas: "bg-[#FFDDB6] text-black"
    };
    return styles[status] || "bg-gray-100 text-gray-600";
  };

  return (
    <div 
      onClick={onClick}
      className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow cursor-pointer"
    >
      {/* Header: ID, Name, Products */}
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs text-gray-500">#{data.lead_id}</span>
            <div className="flex gap-1">
              {data.products?.includes('Remittance') && (
                <img src={RemittanceIcon} alt="Remittance" className="w-4 h-4" />
              )}
              {data.products?.includes('Insurance') && (
                <img src={InsuranceIcon} alt="Insurance" className="w-4 h-4" />
              )}
              {data.products?.includes('Financing') && (
                <img src={FinancingIcon} alt="Financing" className="w-4 h-4" />
              )}
              {data.products?.includes('Referral') && (
                <img src={ReferralIcon} alt="Referral" className="w-4 h-4" />
              )}
              {data.products?.includes('Re-KYC') && (
                <img src={ReKYCIcon} alt="Re-KYC" className="w-4 h-4" />
              )}
            </div>
          </div>
          <h3 className="font-bold text-base text-gray-900">{data.name}</h3>
        </div>
      </div>

      {/* Status Badges */}
      <div className="flex flex-wrap gap-2 mb-3">
        {data.churn_profile && (
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${getChurnStatusStyle(data.churn_profile)}`}>
            {data.churn_profile}
          </span>
        )}
        {data.profile_name && (
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${getProfileStyle(data.profile_name)}`}>
            {data.profile_name}
          </span>
        )}
      </div>

      {/* Details Grid */}
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Farmer:</span>
          <span className="font-medium text-gray-900">{data.farmer_username || 'N/A'}</span>
        </div>
        {data.relationship && (
          <div className="flex justify-between">
            <span className="text-gray-600">Relationship:</span>
            <span className="font-medium text-gray-900">{data.relationship}</span>
          </div>
        )}
        {data.last_transaction_datetime && (
          <div className="flex justify-between">
            <span className="text-gray-600">Last Transacted:</span>
            <span className="font-medium text-gray-900">
              {new Date(data.last_transaction_datetime).toLocaleDateString()}
            </span>
          </div>
        )}
        {data.updated_time && (
          <div className="flex justify-between">
            <span className="text-gray-600">Last Interacted:</span>
            <span className="font-medium text-gray-900">
              {new Date(data.updated_time).toLocaleDateString()}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountCard;

